import * as Yup from 'yup';

export const RefundRequestContactValidation = Yup.object().shape({
    cel: Yup.string()
        .required("Insira um celular válido e correto")
        .matches(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, "Verifique se o telefone está correto, com 11 dígitos"),
    email: Yup.string()
        .required('Insira um e-mail válido e correto').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Insira um e-mail válido e correto')
        .email('Verifique se o e-mail está correto, com @ e ponto'),
})